import { Spinner as SpiceUISpinner } from "@next-platform/client-common-spicy-ui";

import { ISpinnerProps } from "./types";

const Spinner = ({ centerToScreen = false, centerHorizontally = false }: ISpinnerProps) => {
  if (centerToScreen) {
    return (
      <div className="absolute top-0 left-0  flex h-screen w-full justify-center items-center  ">
        <SpiceUISpinner />
      </div>
    );
  }

  if (centerHorizontally) {
    return (
      <div className="flex w-full justify-center items-center">
        <SpiceUISpinner />
      </div>
    );
  }

  return <SpiceUISpinner />;
};

export default Spinner;
